'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var index_es = require('../node_modules/slate/dist/index.es.js');

var LIST_TYPES = ['numbered-list', 'bulleted-list'];
/** Returns `true` if the block is active. */

function isBlockActive(editor, block) {
  var [match] = index_es.Editor.nodes(editor, {
    match: n => !index_es.Editor.isEditor(n) && index_es.Element.isElement(n) && n.type === block
  });
  return Boolean(match);
}
/** Returns `true` if the mark is active. */

function isMarkActive(editor, format) {
  var marks = index_es.Editor.marks(editor);
  return marks ? marks[format] === true : false;
}
/** Toggles an editor mark */

function toggleMark(editor, format) {
  var isActive = isMarkActive(editor, format);
  console.log({
    format,
    isActive
  });

  if (isActive) {
    index_es.Editor.removeMark(editor, format);
  } else {
    index_es.Editor.addMark(editor, format, true);
  }
}
/** Toggles an editor block */

function toggleBlock(editor, format) {
  var isActive = isBlockActive(editor, format);
  var isList = LIST_TYPES.includes(format);
  console.log({
    isActive,
    isList,
    format
  });
  index_es.Transforms.unwrapNodes(editor, {
    match: n => LIST_TYPES.includes(!index_es.Editor.isEditor(n) && index_es.Element.isElement(n) && n.type),
    split: true
  });
  var newProperties = {
    type: isActive ? 'paragraph' : isList ? 'list-item' : format
  };
  index_es.Transforms.setNodes(editor, newProperties);

  if (!isActive && isList) {
    var block = {
      type: format,
      children: []
    };
    index_es.Transforms.wrapNodes(editor, block);
  }
}

exports.isBlockActive = isBlockActive;
exports.isMarkActive = isMarkActive;
exports.toggleBlock = toggleBlock;
exports.toggleMark = toggleMark;
